import { Form, Formik } from 'formik';
import useTranslation from 'next-translate/useTranslation';
import P from 'prop-types';
import React from 'react';
import { Box } from 'rebass';
import { object } from 'yup';

import CardOutlined from '@/components/CardOutlined';
import { Input } from '@/components/Inputs';
import FormButton from '@/components/Inputs/FormButton';
import Text from '@/components/Text';
import { createCommonSchema } from '@/validation';
import TrustNotice from '@/widgets/ReconciliationCustomer/TrustNotice';

const Error = () => {
  const { t } = useTranslation('page-reconciliation');

  return (
    <CardOutlined
      border={1}
      borderColor="#f5dadd"
      my={['1.5rem']}
      py={['15px']}
      px={['15px']}
      backgroundColor="dropzone.red"
    >
      <Box fontSize="14px" color="#a70000">
        <Text lineHeight="24px" fontWeight="bold">
          {t('toastTitle')}
        </Text>
        <Text lineHeight="24px" color="gray" variant="small">
          {t('toastBody')}
        </Text>
      </Box>
    </CardOutlined>
  );
};

const FastSignUpForm = ({ onSubmit, isError }) => {
  const { t } = useTranslation('page-reconciliation');
  const form = t('form', {}, { returnObjects: true });

  const initialValues = {
    proceedingId: '',
    birthDate: '',
  };

  const validationSchema = object().shape(createCommonSchema(initialValues)?.(form?.errorMessage));

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          await onSubmit(values);
          resetForm();
        }}
      >
        <Form>
          <Input name="proceedingId" title={form?.label?.idNumber} width="100%" />
          <Input name="birthDate" type="birthdate" title={form?.label?.dateOfBirthday} width="100%" />
          <Box mt={['1rem']}>
            <Text variant="small" as="p" color="primaryDisabled">
              {form?.termsOfUseText?.preText}
              <a href={form?.termsOfUseText?.url} rel="noreferrer" target="_blank">
                <Text as="span" my="0" interactive variant="smallPrimary">
                  {form?.termsOfUseText?.linkText}
                </Text>
              </a>
            </Text>
            <Text variant="small" as="p" color="primaryDisabled">
              {form?.privacyText?.preText}
              <a href={form?.privacyText?.url} rel="noreferrer" target="_blank">
                <Text as="span" my="0" interactive variant="smallPrimary">
                  {form?.privacyText?.linkText}
                </Text>
              </a>
            </Text>
          </Box>
          <FormButton Icon={null} text={form?.button} variant="primary" />
        </Form>
      </Formik>
      <TrustNotice content={form?.trustText} />
      {isError ? <Error /> : null}
    </>
  );
};

FastSignUpForm.propTypes = {
  onSubmit: P.func.isRequired,
  isError: P.bool.isRequired,
};

export default FastSignUpForm;
